<template>
  <v-form onSubmit="return false;" ref="form" lazy-validation>
    <v-layout
      row
      wrap
      style="background-color: #fff; padding: 2rem 0px 0px 0px;"
    >
      <v-flex xs12 style="padding: 0px 8px 8px 8px;">
        <p class="table_card__info--label" style="font-size:16px">
          Información del periférico
        </p>
      </v-flex>
      <v-flex xs6 style="padding: 8px">
        <span class="table_card__info--label">Tipo de dispositivo</span>
        <input
          class="faccess_input"
          type="text"
          name="name"
          placeholder="Nombre del dispositivo"
          :value="peripheral.type"
          disabled
        />
      </v-flex>

      <v-flex xs6 style="padding: 8px">
        <span class="table_card__info--label">Marca de dispositivo</span>
        <input
          class="faccess_input"
          type="text"
          name="name"
          placeholder="Nombre del dispositivo"
          :value="peripheral.brand"
          disabled
        />
      </v-flex>

      <v-flex xs6 style="padding: 8px">
        <span class="table_card__info--label">Nombre del dispositivo</span>
        <input
          class="faccess_input"
          type="text"
          name="name"
          placeholder="Nombre del dispositivo"
          :value="peripheral.name"
          disabled
        />
      </v-flex>

      <v-flex xs6 style="padding: 8px">
        <span class="table_card__info--label">Referencia</span>
        <input
          class="faccess_input"
          type="text"
          :value="peripheral.reference"
          name="reference"
          placeholder="Referencia"
          disabled
        />
      </v-flex>

      <v-flex xs6 style="padding: 8px" v-if="peripheral.type != 'domo'">
        <span class="table_card__info--label">ID del dispositivo</span>
        <input
          class="faccess_input"
          type="text"
          :value="peripheral.access_device_id"
          name="access_device_id"
          placeholder="ID del dispositivo"
          disabled
        />
      </v-flex>

      <v-flex xs6 style="padding: 8px">
        <span class="table_card__info--label">Locación</span>
        <input
          class="faccess_input"
          type="text"
          :value="peripheral.location_name"
          name="location"
          placeholder="Locación"
          disabled
        />
      </v-flex>

      <v-flex
        xs6
        style="padding: 8px"
        v-if="
          peripheral.type != '' &&
            peripheral.type != 'alarma' &&
            peripheral.device_type != 'Events'
        "
      >
        <span class="table_card__info--label">Dirección de acceso</span>
        <input
          class="faccess_input"
          type="text"
          :value="peripheral_access_direction"
          name="access_direction"
          placeholder="Dirección de acceso"
          disabled
        />
      </v-flex>

      <v-flex xs6 style="padding: 8px" v-if="peripheral.type == 'alarma'">
        <span class="table_card__info--label">Número de abonado</span>
        <input
          class="faccess_input"
          type="text"
          :value="peripheral.account_id"
          name="account_id"
          placeholder="Número de abonado"
          required
          disabled
        />
      </v-flex>

      <v-flex
        v-if="['reconocimiento facial', 'alarma'].includes(peripheral.type)"
        xs6
        style="padding: 8px"
      >
        <span class="table_card__info--label">Conexión directa</span>
        <input
          class="faccess_input"
          type="text"
          name="name"
          placeholder="Conexión directa"
          :value="peripheral.has_direct_connection ? 'ACTIVADA' : 'DESACTIVADA'"
          disabled
        />
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
export default {
  props: {
    peripheral: {
      type: Object
    },
    locations: {
      type: Array
    }
  },
  computed: {
    location() {
      return this.locations
    },

    peripheral_access_direction() {
      return this.peripheral.access_direction === "ENTRY"
        ? "Entrada"
        : this.peripheral.access_direction === "EXIT"
        ? "Salida"
        : this.peripheral.access_direction === "ACCESS"
        ? "Accesos"
        : "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/devices/PeripheralForm.vue